module.exports = __webpack_public_path__ + "img/smartphone.efd7f69d.svg";